import React from "react"

export default function BraintreeLogo() {
  const merchantId = process.env.REACT_APP_BRAINTREE_MERCHANT_ID

  return (
    <div style={{ marginTop: "40px", marginBottom: "20px" }}>
      <span style={{ display: "flex", justifyContent: "center" }}>
        <a
          href={`https://www.braintreegateway.com/merchants/${merchantId}/verified`}
          target="_blank"
        >
          <img
            src="https://s3.amazonaws.com/braintree-badges/braintree-badge-wide-dark.png"
            width="280px"
            height="44px"
            border="0"
          />
        </a>
      </span>
    </div>
  )
}
